import { List, Button, Typography, Empty, Tag } from 'antd';
import { DeleteOutlined, FileOutlined } from '@ant-design/icons';
import type { TopicAttachment } from '@/types/topic';

const { Text } = Typography;

interface Props {
  attachments: TopicAttachment[];
  onRemove: (attachmentId: string) => void;
}

export function AttachmentsTab({ attachments, onRemove }: Props) {
  if (attachments.length === 0) {
    return (
      <Empty description="No attachments. Use the Import flow (Plan 2) to attach a flyer when creating a Topic." />
    );
  }
  return (
    <List
      dataSource={attachments}
      renderItem={(a) => (
        <List.Item
          actions={[
            <Button key="del" danger icon={<DeleteOutlined />} onClick={() => onRemove(a.id)}>
              Remove
            </Button>,
          ]}
        >
          <List.Item.Meta
            avatar={<FileOutlined style={{ fontSize: 24 }} />}
            title={a.filename ?? a.id}
            description={
              <>
                <Tag>{a.id.slice(0, 8)}</Tag>
                {a.url && (
                  <Text type="secondary">
                    <a href={a.url} target="_blank" rel="noopener noreferrer">
                      open
                    </a>
                  </Text>
                )}
              </>
            }
          />
        </List.Item>
      )}
    />
  );
}
